import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Reusable field definition for SSO Identified.
 */
export const SSOIdentified: SimpleFilterDefinition = {
  apiField: 'sso_identified',
  uiField: 'SSO',
  inputType: 'dropdown',
  getAvailableValues: () => Promise.resolve(['Present', 'Missing']),
  operators: ['is'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'SSO',
      operator: 'is',
      value: queryFilter.not ? 'Present' : 'Missing',
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'sso_identified',
      operator: '=',
      value: '{}',
      not: simpleFilter.value === 'Present',
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'sso_identified' &&
      queryFilter.operator === '=' &&
      queryFilter.value === '{}'
    );
  },
};
